import { render, staticRenderFns } from "./InfinityChallengesTab.vue?vue&type=template&id=37d47168&scoped=true&"
import script from "./InfinityChallengesTab.vue?vue&type=script&lang=js&"
export * from "./InfinityChallengesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d47168",
  null
  
)

export default component.exports